// extracted by mini-css-extract-plugin
export default {"allservice":"ServiceFaq_allservice__m6FqO","allservice1":"ServiceFaq_allservice1__oG1Y7","allImg":"ServiceFaq_allImg__n-S6m","allImg1":"ServiceFaq_allImg1__kXFhY"};